(function () {
    "use strict";

    angular
        .module("app.productDetail")
        .controller("ProductDetailController", ProductDetailController);

    ProductDetailController.$inject = [
        "$scope",
        "$rootScope",
        "ProductDetailService",
        "GeneralService",
        "$cookies",
        "$uibModal",
        "SharedData",
        "$sce",
        "ProductService",
        "CartService",
    ];

    function ProductDetailController(
        $scope,
        $rootScope,
        ProductDetailService,
        GeneralService,
        $cookies,
        $uibModal,
        SharedData,
        $sce,
        ProductService,
        CartService
    ) {
        /* jshint validthis:true */
        var vm = this;
        var lastProductView = false;
        vm.productFeatures = [];
        vm.selectedVariant = {};
        vm.SharedData = SharedData;
        vm.productMediaListForSlider = [];
        vm.productMediaListForTechnical = [];
        vm.variantProduct = [];
        vm.relatedProducts = [];
        vm.galleryIdList = [];
        vm.galleryMediaList = {};
        vm.disabledOptions = [];
        function activate() { }

        window.addEventListener(
            "hashchange",
            function () {
                $scope.$apply();
            },
            false
        );

        vm.getBankList = function () {
            GeneralService.GetBanks({
                PageSize: -1,
            }).then(function (data) {
                vm.bankList = data.data;
                vm.commericalBankList = vm.bankList.filter(function (item) {
                    var installment = item.Installment.find(function (subitem) {
                        return (
                            subitem.Commercial == true &&
                            item.ShowInstallments == true
                        );
                    });
                    return installment != null;
                });
                vm.nonCommericalBankList = vm.bankList.filter(function (item) {
                    var installment = item.Installment.find(function (subitem) {
                        return (
                            subitem.Commercial == false &&
                            item.ShowInstallments == true
                        );
                    });
                    return installment != null;
                });
            });
        };

        $scope.$watch(
            function () {
                return location.href;
            },
            function (value) {
                if (value) {
                    var href = value.split("#");
                    var hash = "";
                    if (href.length == 2) {
                        hash = href[1];
                    } else if (href.length > 2) {
                        hash = href.slice(1).join("#");
                    }
                    hash = decodeURI(hash);
                    if (hash != "undefined") {
                        vm.selectedVariant = vm.productFeatures.find(function (
                            item
                        ) {
                            if (!lastProductView) {
                                AddLastViewProductList(item.ProductCode);
                                lastProductView = true;
                            }
                            return item.Code == hash;
                        });
                    }
                }
            }
        );

        $scope.$watchCollection(
            "vm.selectedProductOption",
            function (newValue, oldValue) {
                if (newValue != undefined) {
                    vm.changeProduct(newValue);
                }
            },
            true
        );

        vm.changeProduct = function (selectedProductOption) {
            selectedProductOption = selectedProductOption
                ? selectedProductOption
                : vm.selectedProductOption;
            var result = Object.keys(selectedProductOption).map((key) => [
                key,
                selectedProductOption[key],
            ]);
            var optionValueList = result.map(function (innerArray) {
                return innerArray[1];
            });

            vm.getVariantProduct(optionValueList);
        };

        vm.activateProduct = function (product) {
            if (product) {
                vm.entity = product;
                vm.getProductMediaList();
                vm.getGalleryListLoad();
                vm.getRelatedProducts();
                var url = location.href.contains("#")
                    ? location.href.split("#")[0]
                    : location.href;
                history.replaceState(
                    undefined,
                    undefined,
                    url + "#" + (vm.entity.Code || "")
                );
            }
        };

        vm.activateFirstVariant = function () {
            setTimeout(function () {
                var hash = window.location.hash;
                if (hash) {
                    var includeProperty = vm.getIncludeProperty();
                    includeProperty.push("ProductVariantValue", "WarehouseTotalStock", "WarehouseTotalStock.Warehouse");
                    var href = location.href.split("#");
                    var hash = "";
                    if (href.length == 2) {
                        hash = href[1];
                    } else if (href.length > 2) {
                        hash = href.slice(1).join("#");
                    }
                    hash = decodeURI(hash);
                    ProductDetailService.getProductWithCode({
                        Code: decodeURIComponent(hash),
                        IncludeProperties: includeProperty,
                    }).then(function (data) {
                        if (data && data.data) {
                            vm.activateProduct(data.data);
                            var selectedOptionValueId =
                                data.data.ProductVariantValue.map(function (item) {
                                    return item.ProductOptionValueId;
                                });
                            var temp = [];
                            var resultOptionGroupList = Object.keys(
                                vm.optionGroupList
                            ).map((key) => [key, vm.optionGroupList[key]]);
                            $(resultOptionGroupList).each(function (i, item) {
                                $(item[1]).each(function (y, subItem) {
                                    if (
                                        selectedOptionValueId.includes(subItem.Id)
                                    ) {
                                        temp[item[0]] = subItem.Id;
                                    }
                                });
                            });
                            var result = Object.keys(temp).map((key) => [
                                key,
                                temp[key],
                            ]);
                            var optionValueList = result.map(function (innerArray) {
                                return innerArray[1];
                            });
                            var keyList = optionValueList.join(",");
                            vm.variantProduct[keyList] = data.data;
                            vm.selectedProductOption = temp;
                            $scope.$apply();
                        }
                    });
                } else {
                    var temp = [];
                    var result = Object.keys(vm.optionGroupList).map((key) => [
                        key,
                        vm.optionGroupList[key],
                    ]);
                    $(result).each(function (i, item) {
                        $(item[1]).each(function (y, subItem) {
                            if (subItem.Default) {
                                temp[item[0]] = subItem.Id;
                            }
                        });
                        if (!temp[i]) {
                            temp[item[0]] = item[1][0].Id;
                        }
                    });
                    vm.selectedProductOption = temp;
                    $scope.$apply();
                }
            }, 1000);
        };

        vm.getVariantProduct = function (optionValueList) {
            var includeProperty = vm.getIncludeProperty();
            var keyList = optionValueList.join(",");
            if (vm.variantProduct[keyList]) {
                vm.activateProduct(vm.variantProduct[keyList]);
            } else {
                ProductDetailService.getVariantProduct({
                    ProductId: vm.mainProduct.Id,
                    SelectedIds: optionValueList,
                    IncludeProperties: includeProperty,
                }).then(function (data) {
                    vm.variantProduct[keyList] = data.data;
                    vm.activateProduct(data.data);
                });
            }
        };

        vm.getIncludeProperty = function () {
            var includeProperty = [];
            if (vm.activateBrand) {
                includeProperty.push("ProductBrand.Media");
            }
            if (vm.activateTag) {
                includeProperty.push("ProductTag.Tag.Media");
            }
            if (vm.activateDescription) {
                includeProperty.push("Detail");
                includeProperty.push("ProductCategory.Category");

            }
            if (vm.activateWarehouse) {
                includeProperty.push("WarehouseTotalStock.Warehouse");
            }
            if (vm.activateOptions) {
                includeProperty.push(
                    "ProductOptionValue.Option.TopOption",
                    "ProductOptionValue.OptionValue"
                );
            }
            return includeProperty;
        };

        vm.getGalleryListLoad = function () {
            if (vm.galeryLoad) {
                return;
            }

            vm.galeryLoad = true;

            if (vm.galleryIdList.length == 0) {
                return;
            }
            $(".gallery-mazaka-slider").owlCarousel("destroy");
            for (let index = 0; index < vm.galleryIdList.length; index++) {
                const element = vm.galleryIdList[index];
                vm.galleryMediaList[element] = [];
            }
            if (vm.entity != null || vm.mainProduct != null) {
                var filter = {
                    GalleryId: vm.galleryIdList.join(","),
                    OrProductId: vm.entity ? vm.entity.Id : vm.mainProduct.Id,
                    OrCategoryId: vm.entity
                        ? vm.entity.MainCategoryId
                        : vm.mainProduct.MainCategoryId,
                    IsImage: true,
                };
                GeneralService.getGalleryMediaList(filter).then(function (
                    data
                ) {
                    for (let index = 0; index < data.data.length; index++) {
                        const element = data.data[index];
                        vm.galleryMediaList[element.GalleryId].push(element);
                    }
                    setTimeout(function () {
                        initSlider(".gallery-mazaka-slider");
                    }, 3000);

                    vm.galeryLoad = false;
                });
            }
        };

        vm.OpenPhotosModal = function (productId) {
            ProductDetailService.getProduct(productId).then(function (data) {
                vm.productImages = data.data.ProductMedia;
                setTimeout(function () {
                    $(
                        ".group-product-images .group-product-image"
                    ).magnificPopup({
                        type: "image",
                        gallery: {
                            enabled: true,
                        },
                    });
                    $(
                        $(".group-product-images .group-product-image")[0]
                    ).click();
                }, 100);
            });
        };

        function getCookieByName(name) {
            return $cookies.get(name);
        }

        function setCookie(name, value) {
            $cookies.put(name, value);
        }

        function AddLastViewProductList(value) {
            const unique = (value, index, self) => {
                return self.indexOf(value) === index;
            };
            var lastviewProduct = getCookieByName("LastViewProduct");

            var lastViewProductList = [];
            if (lastviewProduct)
                lastViewProductList = lastviewProduct.split(",");
            if (lastViewProductList) {
                if (!lastViewProductList.find((x) => x == value)) {
                    if (lastViewProductList.length != 5) {
                        lastViewProductList.unshift(value);
                    } else {
                        lastViewProductList.shift();
                        lastViewProductList.unshift(value);
                    }
                }
            }
            lastViewProductList = lastViewProductList.filter(unique);
            setCookie("LastViewProduct", lastViewProductList);
        }

        vm.getTrustUrl = function (url) {
            url = url
                .replace("//", "/")
                .replace("http:/", "http://")
                .replace("https:/", "https://");
            return $sce.trustAsResourceUrl(url);
        };

        vm.getTrustAsHtml = function (html) {
            return $sce.trustAsHtml(html);
        };

        vm.activateForSlider = function () {
            setTimeout(() => {
                if (typeof activateForSlider === "function") {
                    if (
                        window.DetailProductSlider &&
                        typeof window.DetailProductSlider.destroy === "function"
                    ) {
                        window.DetailProductSlider.destroy();
                    }
                    activateForSlider($(".product-slider-detail"));
                }
                if (typeof initSwiper === "function") {
                    initSwiper();
                }
                if (typeof $.fn.magnificPopup === "function") {
                    $(".product-detail-image-list")
                        .find(".product-slider__detailed-link")
                        .magnificPopup({
                            type: "image",
                            gallery: {
                                enabled: true,
                            },
                        });
                }
                if (typeof activateForGroupProducts === "function") {
                    activateForGroupProducts(".product-group-slider__detailed");
                }
            }, 500);
        };

        vm.activateForTechnical = function () {
            setTimeout(() => {
                if (typeof activateForTechnical === "function") {
                    activateForTechnical(".technical-slider__slider");
                }
            }, 500);
        };

        vm.getDefaultPrice = function (product) {
            var defaultPrice = product.PriceWithDiscount;
            if (product.Currency.Default == false) {
                if (product.Price != product.PriceWithDiscount) {
                    defaultPrice =
                        product.PriceWithDiscount *
                        product.DefaultQuantity *
                        product.Currency.Rate;
                } else {
                    defaultPrice = product.Price * product.Currency.Rate;
                }
            }
            return defaultPrice;
        };

        vm.getDefaultPriceWithDiscount = function (product) {
            var defaultNonDiscountPrice = product.Price;
            if (product.Currency.Default == false) {
                if (product.Price != product.PriceWithDiscount) {
                    defaultNonDiscountPrice =
                        product.Price *
                        product.DefaultQuantity *
                        product.Currency.Rate;
                }
            }
            return defaultNonDiscountPrice;
        };

        vm.getDefaultTierPrice = function (tierPrice, product) {
            var defaultTierPrice = tierPrice;
            if (product.Currency.Default == false) {
                defaultTierPrice = tierPrice * product.Currency.Rate;
            }
            return defaultTierPrice;
        };

        vm.getEarnTierPrice = function (tierPrice, product) {
            var earnPerProduct =
                product.PriceWithDiscount * product.DefaultQuantity -
                tierPrice.Price;
            var totalEarn = earnPerProduct * tierPrice.Quantity;
            return totalEarn;
        };

        vm.getTierPriceListWithRole = function (roleId) {
            if (roleId == "" || roleId == null) {
                return vm.entity.TierPrice.filter((k) => k.RoleId == null)
            } else {
                return vm.entity.TierPrice.filter((k) => k.RoleId === roleId);
            }
        };

        vm.getProductMediaList = function () {
            if (
                !vm.activateMediaListForSlider &&
                !vm.activateMediaListForTechnical
            ) {
                return false;
            }
            vm.mediaListForSlider = [];
            vm.mediaListForTechnical = [];
            $(".product-slider-with-thumbnail").css("visibility", "hidden");
            if (vm.productMediaListForSlider[vm.entity.Id]) {
                vm.mediaListForSlider =
                    vm.productMediaListForSlider[vm.entity.Id];
                vm.activateForSlider();
            } else if (vm.productMediaListForTechnical[vm.entity.Id]) {
                vm.mediaListForTechnical =
                    vm.productMediaListForTechnical[vm.entity.Id];
                vm.activateForTechnical();
            } else {
                ProductDetailService.getProductMediaList(vm.entity.Id).then(
                    function (data) {
                        vm.productMediaListForSlider[vm.entity.Id] =
                            data.data.filter(function (element) {
                                return element.ShowSlider == true;
                            });
                        vm.mediaListForSlider =
                            vm.productMediaListForSlider[vm.entity.Id];
                        vm.activateForSlider();
                        vm.productMediaListForTechnical[vm.entity.Id] =
                            data.data.filter(function (element) {
                                return element.IsTechnical == true;
                            });
                        vm.mediaListForTechnical =
                            vm.productMediaListForTechnical[vm.entity.Id];
                        vm.activateForTechnical();
                    }
                );
            }
        };

        vm.getMainProduct = function () {
            setTimeout(function () {
                var includeProperty = vm.getIncludeProperty();
                ProductDetailService.getMainProduct({
                    ProductId: vm.mainProductId,
                    IncludeProperties: includeProperty,
                }).then(function (data) {
                    vm.mainProduct = data.data;
                    vm.getProductVariantList();
                    if (vm.mainProduct.IsMainGroupProduct) {
                        var groupProductIncludeProperty = [];
                        if (vm.activateBrand) {
                            groupProductIncludeProperty.push(
                                "SubProduct.ProductBrand.Media"
                            );
                        }
                        if (vm.activateTag) {
                            groupProductIncludeProperty.push(
                                "SubProduct.ProductTag.Tag.Media"
                            );
                        }
                        if (vm.activateDescription) {
                            groupProductIncludeProperty.push(
                                "SubProduct.Detail"
                            );
                        }
                        groupProductIncludeProperty.push(
                            "SubProduct.ProductVariant"
                        );
                        groupProductIncludeProperty.push(
                            "SubProduct.ProductMedia.Media"
                        );
                        groupProductIncludeProperty.push(
                            "SubProduct.ProductOptionValue.Option"
                        );
                        groupProductIncludeProperty.push(
                            "SubProduct.ProductOptionValue.OptionValue"
                        );
                        ProductDetailService.getGroupProductList({
                            ProductId: vm.mainProductId,
                            IncludeProperties: groupProductIncludeProperty,
                        }).then(function (data) {
                            vm.mainProduct.GroupProduct = data.data;
                            vm.entity = vm.mainProduct;
                            var mainProductListString =
                                vm.mainProduct.GroupProduct.filter(function (
                                    k
                                ) {
                                    return k.SubProduct.Active == true;
                                }).sort(function (a, b) {
                                    return (
                                        a.GroupDisplayOrder -
                                        b.GroupDisplayOrder
                                    );
                                });
                            vm.groupedListString = "";
                            mainProductListString.forEach(function (
                                groupProduct
                            ) {
                                if (groupProduct.DefaultGroupQuantity > 0) {
                                    vm.groupedListString +=
                                        groupProduct.SubProduct.Name +
                                        " (" +
                                        groupProduct.DefaultGroupQuantity +
                                        ") ";
                                }
                            });
                            vm.loadEntity();
                            setTimeout(() => {
                                if (typeof activateForSlider === "function") {
                                    activateForSlider(
                                        $(".product-group-slider__detailed")
                                    );
                                }
                            }, 1000);
                        });
                    } else if (vm.mainProduct.IsMainVariantProduct) {
                        ProductDetailService.getVariantProductList(
                            vm.mainProductId
                        ).then(function (data) {
                            vm.entity = vm.mainProduct;
                            vm.loadEntity();
                            vm.mainProduct.ProductOptionValue = data.data;
                            var filteredSpesificValues =
                                vm.mainProduct.ProductOptionValue.filter(
                                    function (k) {
                                        return k.IsSpecific;
                                    }
                                ).sort(function (a, b) {
                                    return (
                                        a.Option.DisplayOrder -
                                        b.Option.DisplayOrder
                                    );
                                });
                            var filteredNonSpesificValues =
                                vm.mainProduct.ProductOptionValue.filter(
                                    function (k) {
                                        return !k.IsSpecific;
                                    }
                                ).sort(function (a, b) {
                                    return (
                                        a.Option.DisplayOrder -
                                        b.Option.DisplayOrder
                                    );
                                });
                            var groupedValues = {};
                            if (filteredNonSpesificValues) {
                                filteredNonSpesificValues.forEach(function (k) {
                                    if (!groupedValues[k.OptionId]) {
                                        groupedValues[k.OptionId] = [];
                                    }
                                    groupedValues[k.OptionId].push(k);
                                });
                            }
                            vm.optionGroupList = groupedValues;
                            var groupedValuesTopOptionForSpesific = {};
                            filteredSpesificValues.forEach(function (k) {
                                if (
                                    !groupedValuesTopOptionForSpesific[
                                    k.Option.TopOption
                                    ]
                                ) {
                                    groupedValuesTopOptionForSpesific[
                                        k.Option.TopOption
                                    ] = [];
                                }
                                groupedValuesTopOptionForSpesific[
                                    k.Option.TopOption
                                ].push(k);
                            });
                            vm.optionGroupSpesificListForTopOption =
                                groupedValuesTopOptionForSpesific;
                            vm.mainProductNonSpesific =
                                vm.mainProduct.ProductOptionValue.some(
                                    function (k) {
                                        return !k.IsSpecific;
                                    }
                                );
                            vm.activateFirstVariant();
                        });
                    } else {
                        vm.entity = vm.mainProduct;
                        vm.loadEntity();
                    }
                });
            }, 500);
        };

        vm.loadEntity = function () {
            setTimeout(() => {
                vm.getProductMediaList();
                vm.getRelatedProducts();
                if (vm.activateTag) {
                    vm.productTagFilter = vm.entity.ProductTag.filter(function (
                        element
                    ) {
                        return element.Tag.Active == true;
                    });
                    vm.productTagList = vm.entity.ProductTag.filter(function (
                        element
                    ) {
                        return (
                            element.Tag.Active == true &&
                            element.Tag.ShowinProductDetail == true
                        );
                    });
                }
                if (typeof initSlider === "function") {
                    initSlider();
                }
            }, 500);
        };
        vm.getLastViewedProductList = function () {
            ProductDetailService.getLastViewedProductList().then(function (
                data
            ) {
                vm.lastViewedProductList = data.data.Data;
                setTimeout(() => {
                    initSlider(".last-viewed-products-part__slider");
                }, 500);
            });
        };

        vm.getRelatedProducts = function () {
            ProductDetailService.getRelatedProducts({
                CategoryId: vm.relatedCategoryId,
                ProductId: vm.entity.Id,
                ProductQuantity: vm.relatedQuantity,
                InStock: vm.relatedStock,
            }).then(function (data) {
                vm.relatedProducts = data.data;
                console.log(vm.entity.Id);
                vm.checkFavorite(vm.relatedProducts);
                $(".product-related-products-part__slider").owlCarousel("destroy");
                setTimeout(() => {
                    initSlider(".product-related-products-part__slider");
                }, 1000);
            });
        };


        vm.checkFavorite = function (productList) {
            for (let index = 0; index < productList.length; index++) {
                if (vm.IsInFavorite(productList[index])) {
                    productList[index].IsInFavorite = true;
                } else {
                    productList[index].IsInFavorite = false;
                }
            }
        };

        vm.IsInFavorite = function (product) {
            var editFavCartProduct = vm.getFavoriteProducts(product);
            if (editFavCartProduct.length > 0) {
                return true;
            }
            return false;
        };

        vm.DeleteFavoriteCartProduct = function (product) {
            var editFavCartProduct = vm.getFavoriteProducts(product);
            if (editFavCartProduct.length > 0) {
                CartService.Delete(editFavCartProduct[0]).then(function () {
                    CartService.getCart({ CartType: "Favorite" }).then(
                        function (_cart) {
                            $rootScope.favoriteCart = _cart;
                            vm.checkFavorite(vm.relatedProducts);
                            $.each(vm.relatedProductList, function (key, value) {
                                vm.checkFavorite(vm.relatedProductList[key]);
                            });
                        }
                    );
                });
            }
        };

        vm.getRelatedProductList = function (productId, relatedProductTypeId) {
            vm.relatedProductList = vm.relatedProductList || {};
            ProductDetailService.getRelatedProductList({
                ProductId: productId,
                RelatedProductTypeId: relatedProductTypeId,
            }).then(function (data) {
                vm.relatedProductList[relatedProductTypeId] = data.data || [];
                vm.checkFavorite(data.data);
                setTimeout(() => {
                    initSlider(".product-related-products-part-list");
                }, 500);
            });
        };

        vm.AddFavoriteCartProduct = function (product) {
            var editFavCartProduct = vm.getFavoriteProducts(product);
            if (editFavCartProduct.length == 0) {
                var params = {
                    productID: product.Id,
                    CartType: "Favorite",
                };
                CartService.InsertWithParams(params).then(function () {
                    CartService.getCart({ CartType: "Favorite" }).then(
                        function (_cart) {
                            $rootScope.favoriteCart = _cart;
                            var elemetn1 = $('[data-id="' + product.Id + '"]');

                            var closestSibling = elemetn1.siblings('.product-successfully-add-box');
                            var successTextElement = closestSibling.find('.FavoriteText');

                            successTextElement.css({ "display": "" });
                            setTimeout(function () {
                                successTextElement.css({ "display": "none" });
                            }, 2000);
                            vm.checkFavorite(vm.relatedProducts);
                            $.each(vm.relatedProductList, function (key, value) {
                                vm.checkFavorite(vm.relatedProductList[key]);
                            });
                        }
                    );
                });
            }
        };

        vm.getFavoriteProducts = function (product) {
            if ($rootScope.favoriteCart) {
                var favoriteProductList = $rootScope.favoriteCart.CartProduct;
                var filterFavorites = favoriteProductList.filter(function (
                    item
                ) {
                    return item.ProductId.includes(product.Id);
                });
                return filterFavorites;
            } else {
                return [];
            }
        };



        vm.getProductReviewList = function (productId) {
            ProductDetailService.getProductReviewList(productId).then(function (
                data
            ) {
                vm.productReviewList = data.data;
                vm.reviewAvarageValue = 0;

                if (vm.productReviewList.length > 0) {
                    var sum = 0;
                    var count = vm.productReviewList.length;

                    for (var i = 0; i < count; i++) {
                        sum += vm.productReviewList[i].Rating;
                    }

                    var average = sum / count;
                    vm.reviewAvarageValue = average.toFixed(2);

                    setTimeout(function () {
                        $(".listRate").each(function (i, obj) {
                            var ratingValue =
                                obj.attributes["data-value"].value;
                            if (ratingValue !== null) {
                                $(obj).rateYo({
                                    starWidth: "20px",
                                    rating: ratingValue,
                                    readOnly: true,
                                });
                            }
                        });
                    }, 100);
                }
            });
        };

        vm.getValueSettings = function (settings, variable) {
            var value = JSON.parse(settings || "{}");
            if (!value) {
                return null;
            }
            return value[variable];
        };

        vm.getLabel = function (optionId, productOptionValueId) {
            var getLabel = vm.optionGroupList[optionId].find(function (item) {
                return item.Id == productOptionValueId;
            });
            if (!getLabel) {
                return "";
            }
            return getLabel.OptionValue;
        };

        vm.getAllSubProduct = function () {
            var includeProperty = vm.getIncludeProperty();
            includeProperty.push("Currency");
            includeProperty.push("TierPrice");
            includeProperty.push("Discount");
            includeProperty.push("ProductMedia.Media");
            includeProperty.push("ProductVariantValue");
            var params = {
                BaseProductId: vm.mainProductId,
                IncludeProperties: includeProperty,
                PageSize: -1,
            };
            ProductService.filter(params).then(function (data) {
                vm.mainProduct.ProductVariant = data.Data;
                $(data.Data).each(function (i, item) {
                    vm.productMediaListForSlider[item.Id] = item.ProductMedia;
                    var optionValueList = item.ProductVariantValue.map(
                        (x) => x.ProductOptionValueId
                    );
                    var keyList = optionValueList.join(",");
                    vm.variantProduct[keyList] = item;
                });
            });
        };

        vm.getProducts = function (params) {
            return ProductService.filter(params).then(function (data) { return data; });
        }

        vm.getSubProductWithOptionValueId = function (
            ProductOptionValueId,
            OptionId
        ) {
            var selectedOptions = [];
            if (OptionId) {
                if (vm.selectedProductOption) {
                    var selectedOptionsTemp = Object.keys(
                        vm.selectedProductOption
                    )
                        .map((key) => [key, vm.selectedProductOption[key]])
                        .filter((item) => item[0] != OptionId)
                        .map((item) => item[1]);
                    selectedOptionsTemp.push(ProductOptionValueId);
                    selectedOptions =
                        selectedOptions.concat(selectedOptionsTemp);
                }
            } else {
                var selectedOptionsTemp = [];
                selectedOptionsTemp.push(ProductOptionValueId);
                selectedOptions = selectedOptions.concat(selectedOptionsTemp);
            }

            var a = vm.mainProduct.ProductVariant.find(function (item) {
                var allOptionValues = item.ProductVariantValue.map(
                    (x) => x.ProductOptionValueId
                );
                return selectedOptions.every((item) =>
                    allOptionValues.includes(item)
                );
            });

            return a;
        };

        vm.getMainProductOption = function (optionId) {
            if (vm.mainProduct.ProductOptionValue) {
                return vm.mainProduct.ProductOptionValue.find(function (item) {
                    item.OptionId == optionId;
                });
            }
        };
        vm.getDataFromJsonObject = function (json) {
            try {
                return JSON.parse(json);
            } catch (e) {
                return [];
            }
        };

        vm.getJsonTotalVal = function (json, key) {
            if (!json) {
                return 0;
            }
            return JSON.parse(json).reduce((sum, item) => {
                if (item.hasOwnProperty(key)) {
                    return sum + item[key];
                }
                return sum;
            }, 0);
        }

        vm.getProductVariantList = function () {
            var includeProperty = [];
            includeProperty.push("ProductVariantValue");
            var params = {
                BaseProductId: vm.mainProductId,
                IncludeProperties: includeProperty,
                SelectFields: "ProductVariantValue",
                PageSize: -1
            };
            vm.getProducts(params).then(function (data) {
                vm.ProductVariantList = data.Data;
            });
        };

        vm.checkInitOptions = function () {
            setTimeout(function () {
                var productCode = location.href.split('#');
                if (!location.href.contains('#') || productCode.length < 2 || !productCode[1]) {
                    vm.beforeChangeProduct(vm.mainProduct.ProductOptionValue[0])
                } else {
                    $($(".control-type-wrapper.active input")[0]).click();
                    vm.initOptions();
                }
            }, 1000)
        }

        vm.beforeChangeProduct = function (that) {
            var value = null;
            var optionId = null;
            if (that && that.value) {
                value = that.value.Id;
                optionId = that.value.OptionId;
            } else if (that) {
                value = that.Id;
                optionId = that.OptionId;
            }
            var productOptionValues = Object
                .keys(vm.selectedProductOption)
                .map((key) => [
                    key,
                    vm.selectedProductOption[key],
                ])
                .filter(item => item[0] != undefined)
                .map(item => item[1]);
            productOptionValues = [...new Set(productOptionValues)];
            if (!vm.ProductVariantList) {
                return;
            }
            var selectedVariants = vm.ProductVariantList.filter(x => {
                var allProductOptionValueId = x.ProductVariantValue.map(d => d.ProductOptionValueId);
                return productOptionValues.every(f => allProductOptionValueId.includes(f));
            });
            if (selectedVariants.length > 0) {
                var selectedVariant = selectedVariants[0];
                var dataOptionsList = selectedVariant.ProductVariantValue.map(x => x.ProductOptionValueId);
                var dataOptionsListDiff = dataOptionsList.filter(function (x) { return !productOptionValues.includes(x); });
                $(dataOptionsListDiff).each(function (i, item) {
                    var productOptionValue = vm.mainProduct.ProductOptionValue.find(x => x.Id == item);
                    vm.selectedProductOption[productOptionValue.OptionId] = item;
                });
            } else {
                var controls = Object
                    .keys(vm.selectedProductOption)
                    .map((key) => [
                        key,
                        vm.selectedProductOption[key],
                    ])
                    .filter(item => item[0] != undefined && item[0] != optionId);
                controls = [...new Set(controls)];
                var controlSelector = [];
                controlSelector[optionId] = value;
                $(controls).each(function (i, item) {
                    var selectedVariant = vm.ProductVariantList.filter(x => {
                        var allProductOptionValueId = x.ProductVariantValue.map(d => d.ProductOptionValueId);
                        var productOptionValueIds = Object.keys(controlSelector).map((key) => controlSelector[key]);
                        productOptionValueIds.push(item[1]);
                        return productOptionValueIds.every(f => allProductOptionValueId.includes(f));
                    });
                    if (selectedVariant.length > 0) {
                        controlSelector[item[0]] = item[1];
                    }
                });
                vm.selectedProductOption = controlSelector;
                vm.beforeChangeProduct(that);
                return;
            }
            vm.initOptions(that);
            vm.changeProduct();
            $("li.disabled-order").removeClass("disabled-order");
            $(".control-type-wrapper.disabled-varyant").each(function (i, item) { $(item).closest("li").addClass("disabled-order") });
        }

        vm.initOptions = function () {
            $(vm.mainProduct.ProductOptionValue).each(function (i, item) {
                if (!vm.disabledOptions[item.OptionId]) {
                    vm.disabledOptions[item.OptionId] = [];
                }
                vm.disabledOptions[item.OptionId][item.Id] = true;
            });
            var optionList = Object
                .keys(vm.optionGroupList)
                .map((key) => key);
            var excludeOptionList = vm.mainProduct
                .ProductOptionValue
                .filter(x => x.Option.Name == 'Renk Adı' || x.Option.Name == 'Fırça Uç No' || x.Option.Name == 'Set Adı')
                .map(x => x.OptionId);
            excludeOptionList = [...new Set(excludeOptionList)];

            $(optionList).each(function (i, item) {
                var optionId = item;
                var selectedOtherOptions = Object
                    .keys(vm.selectedProductOption || [])
                    .map((key) => [
                        key,
                        vm.selectedProductOption[key],
                    ])
                    .filter(item => item[0] != optionId && !excludeOptionList.includes(item[0]))
                    .map(item => item[1]);
                var otherOptionList = [];
                var selectedVariant = vm.ProductVariantList.filter(x => {
                    var allProductOptionValueId = x.ProductVariantValue.map(d => d.ProductOptionValueId);
                    return selectedOtherOptions.every(f => allProductOptionValueId.includes(f));
                });
                $(selectedVariant).each(function (i, item) {
                    var allProductOptionValueId = item.ProductVariantValue.map(x => x.ProductOptionValueId)
                    otherOptionList = otherOptionList.concat(allProductOptionValueId);
                })
                otherOptionList = [...new Set(otherOptionList)];
                $(otherOptionList).each(function (i, option) {
                    vm.disabledOptions[optionId][option] = false;
                });
            });
        }

        vm.parseAndChangeNumeriValue = function (name, value) {
            if (name.includes("kg") || name.includes("Kg")) {
                var numericValue = parseFloat(value);
                if (numericValue < 1 && numericValue > -1) {
                    numericValue = numericValue * 100;
                    return numericValue.toFixed(1);
                }
                var formattedValue = numericValue.toFixed(1);
                return parseFloat(formattedValue);
            } else {
                return value;
            }

        }

        vm.calculateDiscountAmount = function (price, cartPrice) {
            if (price && cartPrice && price > 0 && cartPrice > 0) {

                var discountPercentage = 100 - ((cartPrice / price) * 100);

                var discountAmount = price - cartPrice;

                return {
                    discountPercentage: discountPercentage,
                    discountAmount: discountAmount
                };
            } else {
                return {
                    discountPercentage: 0,
                    discountAmount: 0
                };
            }
        }

        vm.GetVariantData = function () {

            let variantValue = {};
            const keyValuePairs = vm.selectedProductOption
            for (let key in keyValuePairs) {
                if (keyValuePairs.hasOwnProperty(key)) {

                    let optionId = key;
                    let option = vm.entity.ProductOptionValue.find(o => o.Option.Id === optionId);
                    if (option) {
                        variantValue[option.Option.Name] = option.OptionValue.Value;
                    }
                }
            }

            let jsonStringVariant = JSON.stringify(variantValue, null, 2);

            return jsonStringVariant;

        }

        vm.AddCartDetail = function (that) {

            if (
                marketMode &&
                marketMode == "True" &&
                !localStorage.getItem("deliveryAddressNames")
            ) {
                $(".select-location").trigger("click");
                $(".delivery-notifications").show();
                $(".close").click(function () {
                    $(".modal-backdrop").fadeOut("fast");
                });
                $("#locationModal").change(function () {
                    $(".modal-backdrop").fadeOut("fast");
                });
                if ($("#locationModal").length <= 0) {
                    locationError
                    $("#errorModalAlertDiv").modal("show");
                    $("#errorModalAlertDiv .error-modal-content").html(
                        locationAlertError
                    );
                }
                return;
            }
            $(that).attr("disabled", true);

            var addCartType = $("#CartController").attr("add-cart-loader");
            var detailLoader = $(that).find(".add-cart-detail-loader");
            $(detailLoader).removeClass("d-none");
            if (addCartType === "cart") {
                var loading = $(that)
                    .closest(".product-add-to-cart")
                    .find(".loading");
                $(loading).fadeIn("fast");
            } else if (addCartType === "popup") {
                $("#add-cart-modal .cart-modal-loading").show();
                $("#add-cart-modal .cart-modal-content").hide();
                $("#add-cart-modal").modal("show");
            }

            if (vm.entity.HasVariants == true) {
                var variantValues;
                if (vm.entity.ProductVariantString) {
                    variantValues = vm.entity.ProductVariantString;
                } else {
                    variantValues = vm.GetVariantData(that);
                }

                var addCartType = $("#CartController").attr("add-cart-type");
                if (addCartType === "cart") {
                    var loading = $(that)
                        .closest(".product-add-to-cart")
                        .find(".loading");
                    $(loading).fadeIn("fast");
                } else if (addCartType === "popup") {
                    $("#add-cart-modal .cart-modal-loading").show();
                    $("#add-cart-modal .cart-modal-content").hide();
                    $("#add-cart-modal").modal("show");
                } else {
                    var loadingCart = $(that)
                        .closest(".product-add-to-cart")
                        .find(".loading");
                    $(loadingCart).fadeIn("fast");
                }

                var productID = vm.entity.Id;

                var tierPriceQuantity = $(that).attr("data-tier-price-quantity");
                var addToCartAmount = $(that)
                    .parent()
                    .find("[name='addToCartAmount'][data-id='" + productID + "']");
                var addToCartAmount2 = $(
                    "[name='addToCartAmount'][data-id='" + productID + "']"
                );

                var dynamicQuantity;
                if (vm.dynamicQuantityValue) {
                    dynamicQuantity = parseFloat(vm.dynamicQuantityValue);
                }

                var quantity = 1;
                if (isNaN(parseFloat(tierPriceQuantity)) == false) {
                    quantity = parseFloat($(tierPriceQuantity).val());
                } else if (isNaN(parseFloat($(addToCartAmount).val()))) {
                    quantity = parseFloat($(addToCartAmount2).val());
                } else {
                    quantity = parseFloat($(addToCartAmount).val());
                }
                if ($(that).parent().find(".overage-control")) {
                    var overage = parseFloat(
                        $(that).parent().find(".overage-control select").val() || 0
                    );
                    var quantity2 = parseFloat(
                        $(that)
                            .parent()
                            .find(".overage-control")
                            .parent()
                            .find("[name='addToCartAmount']")
                            .val() || 1
                    );
                    var newQuantity = Math.ceil(
                        quantity + (quantity * overage) / 100
                    );
                    quantity2 = newQuantity;
                }
                var defaultIncrement = vm.entity.DefaultIncrement;
                if (quantity == 0 && $(".group-product-quantity").length > 0) {
                    quantity += defaultIncrement;
                    quantity2 = quantity;
                }
                var isGroupProduct = vm.entity.IsMainGroupProduct;
                var currency = vm.entity.Currency.ShortName;
                var productCode = vm.entity.Code;
                var image = isGroupProduct
                    ? $(that).attr("data-base-group-product-img")
                    : vm.entity.FirstImage;

                var analytics = null;

                if (vm.entity.AnalyticsData)
                    analytics = JSON.parse(vm.entity.AnalyticsData)
                        .products[0];

                var name = vm.entity.Name;
                var defaultQuantity = vm.entity.DefaultQuantity;
                var price = vm.entity.PriceWithDiscount;
                var warehouseId = $(
                    "[data-id='" + productID + "'][id = 'warehouseId']"
                ).val();

                var description = vm.entity.Description;
                var params = {
                    productID: vm.entity.Id,
                    quantity: quantity || vm.entity.DefaultQuantity,
                    dynamicQuantity: dynamicQuantity,
                    WarehouseId: warehouseId,
                    AddCartType: addCartType,
                    Description: description
                };

                if (variantValues && variantValues.length != 0) {
                    params.variantValues = variantValues;
                }
                var baseGroupProductName = "";
                var baseGroupProductLink = "";
                var baseGroupProductImg = "";

                if (vm.entity.ProductGroup && vm.entity.ProductGroup.length > 0) {
                    baseGroupProductName = vm.entity.Name;
                    baseGroupProductLink = vm.entity.Link;
                    baseGroupProductImg = vm.entity.FirstImage;

                }



                if (baseGroupProductName) {
                    params["BaseGroupProductName"] = baseGroupProductName;
                    params["BaseGroupProductLink"] = baseGroupProductLink;
                    params["BaseGroupProductImage"] = baseGroupProductImg;
                }

                var promiseInsertCart = (window.promiseInsertCart = angular
                    .element("#CartController")
                    .scope()
                    .vm.InsertWithParams(params));

                promiseInsertCart.then(
                    function () {
                        $(that).attr("disabled", false);
                        if (addCartType === "popup") {
                            $('.add-cart-detail-loader').addClass('d-none');
                            $("#add-cart-modal .cart-modal-product-image").attr(
                                "src",
                                imageServer + "/" + image
                            );
                            $(
                                "#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box svg"
                            ).show();
                            $(
                                "#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box__text"
                            ).show();
                            $(
                                "#add-cart-modal .cart-modal-product-name"
                            ).removeClass("errorClass");

                            $("#add-cart-modal .error_text").hide();
                            $("#add-cart-modal .cart-modal-product-name").html(
                                name
                            );
                            $("#add-cart-modal .cart-modal-product-name").show();
                            $("#add-cart-modal #addCartQuantity").html(quantity);
                            $(
                                "#add-cart-modal .cart-modal-product-price-with-discount"
                            ).html(
                                vm.formatCurrency(parseFloat((price && typeof price === 'string' ? price.replace(",", ".") : price.toString().replace(",", "."))) * (quantity2 ? quantity2 : defaultQuantity), currency)
                            );
                            $(
                                "#add-cart-modal .cart-modal-product-price-with-quantity"
                            ).html(quantity2 ? quantity2 : defaultQuantity);
                            $("#add-cart-modal .cart-modal-loading").hide();
                            $("#add-cart-modal .cart-modal-content").show();
                            var loading = $(that)
                                .closest(".product-add-to-cart")
                                .find(".loading");
                            $(loading).fadeOut("fast");

                        } else if (addCartType === "cart") {
                            window.location = "/Cart/Index";
                        } else {


                            var success = $(that)
                                .closest(".product-add-to-cart")
                                .find(".SuccessTextDetail");
                            var loading = $(that)
                                .closest(".product-add-to-cart")
                                .find(".loading");
                            $(loading).fadeOut("fast");
                            $(success).fadeIn("fast").delay(1000).fadeOut("fast");
                            $(success).addClass("end-0");
                            //$(".quic-view").modal("hide");
                            //angular.element("#CartController").scope().vm.getCart();


                        }
                        $(detailLoader).addClass("d-none");
                    },
                    function (error) {
                        $(that).attr("disabled", false);
                        if (addCartType === "popup") {
                            $("#add-cart-modal .cart-modal-loading").hide();
                            $("#add-cart-modal").modal("hide");
                            $("#add-cart-modal .cart-modal-product-image").attr(
                                "src",
                                imageServer + "/" + image
                            );
                            $("#add-cart-modal .cart-modal-product-name").addClass(
                                "errorClass"
                            );
                            $("#add-cart-modal .cart-modal-product-name").html(
                                error
                            );
                            $(
                                "#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box svg"
                            ).hide();
                            $(
                                "#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box__text"
                            ).hide();
                            $("#add-cart-modal .error_text").show();
                            $("#add-cart-modal #addCartQuantity").hide();

                            $("#add-cart-modal .cart-modal-content").show();
                        } else if (addCartType === "cart") {
                        } else {

                            /**/
                            $("#add-cart-modal").modal("show");
                            $("#add-cart-modal .modal-body").html(error.toString().split(':')[1] + `
                            <div class="user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box cart-modal-success-icon d-flex gap-1 align-items-center justify-content-center d-none">
                            <span class="user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box__text">Complementary  Products</span>
                            </div>`);

                            $("#add-cart-modal .modal-header").html();
                            $("#add-cart-modal .user-cart__cart-added-modal__dialog").css("max-width", "200px");
                            $(".user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box__text").css("display", "");
                            //user - cart__cart - added - modal__dialog__content__modal - header__button
                            $(".user-cart__cart-added-modal__dialog__content__modal-header__button").removeClass("d-none");
                            $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box__text:before").css("content", "none");
                            $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__header").removeClass("justify-content-between");
                            $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__header").addClass("justify-content-center");

                            $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__modal-header__button").addClass("errorClassCloseButton");
                            $("#add-cart-modal .cart-modal-loading").hide();
                            $("#add-cart-modal .modal-content").addClass("errorClass");
                            $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__navigation-links").removeClass("d-flex");
                            $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__navigation-links").hide();
                            $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box__text").hide();
                            var loading = $(that)
                                .closest(".product-add-to-cart")
                                .find(".loading");
                            $(loading).fadeOut("fast");
                        }
                        $(detailLoader).addClass("d-none");
                    }
                );
            } else {

                $(that).attr("disabled", false);
                $("#errorModalAlertDiv").modal("show");
                $("#errorModalAlertDiv .error-modal-content").html(
                    variantSelectError
                );
            }
            $(that).attr("disabled", false);
        }

        vm.formatCurrency = function (value, currency, locale = "tr-TR") {
            try {
                var formatter = new Intl.NumberFormat(locale, {
                    style: "currency",
                    currency: currency
                });

                return formatter.format(value);
            } catch (error) {
                console.error("Invalid currency code or locale:", error);
                return value.toFixed(2) + " " + currency;
            }
        }


        activate();
    }
})();
